export default function RequiredAsterisk() {
  return <span className="text-red-600">*</span>;
}
